import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  navBar: {
    borderBottom: `1px solid ${Common.borderColor}`,
    height: Common.navbarHeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'relative'
  },
  search: {
    width: 150,
    height: 25,
    paddingLeft: 30,
    borderRadius: 15,
    WebkitAppearance: 'none',
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, .075)',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    transition: 'border-color ease-in-out .15s, box-shadow ease-in-out .15s',
    outline: '0',
    border: '1px solid #ccc',
    fontSize: 13
  },
  searchContainer: {
    order: 1,
    width: 200,
    marginLeft: 20,
    marginTop: -8
  },
  searchIcon: {
    marginTop: -22,
    marginLeft: 5,
    height: 16,
    width: 16
  },
  actionContainer: {
    height: '100%',
    order: 2,
    flex: 2,
    display: 'flex',
    alignItems: 'center'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/NavigationBar/styles.js